import React from 'react';
import styled from 'styled-components';

import DesignerDisplay from '../designer/DesignerDisplay';
import {media} from '../styles/breakpoints';

const PatternDescription = ({ pattern, designer, sewpatId }) => {
    const StyledThing = styled.div`
        display: flex;  
        align-items: center;
        flex-direction: row;
        
        ${media.tweak700up`
            flex-direction: column;
        `};
    `;

    const name = `${pattern.title} by ${designer.name},patterndesigns.com`;

    return (
        <StyledThing>
            <DesignerDisplay designer={designer} sewpatId={sewpatId} />
            <p>{pattern.title}: {pattern.description}</p>
            <meta itemProp='name' content={name} />
            <meta itemProp='description' content={pattern.description} />
        </StyledThing>
    );
};

export default PatternDescription;



// WEBPACK FOOTER //
// ./src/components/pattern/PatternDescription.js